// extracted by mini-css-extract-plugin
export default {"container":"Page_container__Vflf-","top":"Page_top__i6W-s","noBackBtn":"Page_noBackBtn__34JVS"};